import { CommonResponse, LotDetailsResModel, RejectionResponseModel, RejectionsDto, RejectionsResponseModel } from '@gtpl/shared-models/production-management';

import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { RejectionDataDto } from './dto/rejection-data.dto';
import { RejectionRequest } from './dto/rejection-detail -id-request';
import { PlantRequest } from './dto/rejection.request';
import { RejectionsService } from './rejections.service';
@ApiTags('QA-QC Rejections')
@Controller('rejections')
export class RejectionsController {
    constructor(
        private rejectionsService: RejectionsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) { }

    @Post('/createRejectionAssignment')
    async createRejectionAssignment(@Body() inputReq: RejectionsDto): Promise<RejectionsResponseModel> {
        try {
            // console.log('inputReq'+inputReq);
            return await this.rejectionsService.createRejectionAssignment(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RejectionsResponseModel, error);
        }
    }

    @Post('/createRejection')
    async createRejection(@Body() inputReq: RejectionDataDto): Promise<CommonResponse> {
        try {
            return await this.rejectionsService.createRejection(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getAllLotDetailsInfo')
    async getAllLotDetailsInfo(@Body() req: PlantRequest): Promise<LotDetailsResModel> {
        try {
            return await this.rejectionsService.getAllLotDetailsInfo(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(LotDetailsResModel, error);
        }
    }
    @Post('/getDetailViewById')
    async getDetailViewById(@Body() rejectionRequest: RejectionRequest): Promise<RejectionResponseModel> {
        try {
            return await this.rejectionsService.getDetailViewById(rejectionRequest);
        } catch (err) {
            throw err;
        }
    }

    @Post('/getAllRejectedLots')
    async getAllRejectedLots(): Promise<RejectionResponseModel> {
        try {
            return await this.rejectionsService.getAllRejectedLots();
        } catch (err) {
            throw err;
        }
    }

}
